/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DowngradeSubscriptionResponse interface.
 */
export function instanceOfDowngradeSubscriptionResponse(value) {
    if (!('currentTier' in value) || value['currentTier'] === undefined)
        return false;
    if (!('effectiveAt' in value) || value['effectiveAt'] === undefined)
        return false;
    if (!('pendingDowngradeTier' in value) || value['pendingDowngradeTier'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
export function DowngradeSubscriptionResponseFromJSON(json) {
    return DowngradeSubscriptionResponseFromJSONTyped(json, false);
}
export function DowngradeSubscriptionResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'currentTier': json['current_tier'],
        'effectiveAt': json['effective_at'],
        'pendingDowngradeTier': json['pending_downgrade_tier'],
        'status': json['status'],
    };
}
export function DowngradeSubscriptionResponseToJSON(json) {
    return DowngradeSubscriptionResponseToJSONTyped(json, false);
}
export function DowngradeSubscriptionResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'current_tier': value['currentTier'],
        'effective_at': value['effectiveAt'],
        'pending_downgrade_tier': value['pendingDowngradeTier'],
        'status': value['status'],
    };
}
